export default "__VITE_ASSET__R37kLHhM__"